<ng-template #cellContent let-item="data.item" let-elem="data.elem">
	<ng-container *ngIf="item.column_type !== 'button' && item.column_type !== 'select' && item.column_type !== 'add-button'">
		<ng-container *ngIf="getTemplateRefByColumnKey(item.column_key); else elseBlock">
			<ng-template *ngTemplateOutlet="getTemplateRef('DataCell'); context: {data: elem}">
			</ng-template>
		</ng-container>

		<ng-template #elseBlock>
			<ng-container *ngIf="item.column_type !== 'phone' && item.column_type !== 'progress' && item.column_key !== 'note'">
				{{getCellValue(elem, item)}}
			</ng-container>

			<ng-container *ngIf="item.column_key === 'note'">
				<div [innerHTML]="getCellValue(elem, item)"></div>
			</ng-container>

			<ng-template [ngIf]="item.column_type === 'phone'">
				{{getCellValue(elem, item) | mask: '(000)000-0000'}}
			</ng-template>

			<ng-template [ngIf]="item.column_type === 'progress'">
				{{getProgress(elem)}}
			</ng-template>
		</ng-template>
	</ng-container>

	<ng-container *ngIf="item.column_type === 'button'">
		<ng-template *ngTemplateOutlet="getTemplateRef('DataCell'); context: {data: elem}">
		</ng-template>
	</ng-container>

	<ng-container *ngIf="item.column_type === 'add-button' && elem.is_claimant !== 1">
		<button class="table-button-complete"
				title="{{item.column_btn_title}}">
			<svg class="table-button__icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 1000 1000" enable-background="new 0 0 384 384" xml:space="preserve">
												<metadata> Svg Vector Icons : http://www.onlinewebfonts.com/icon </metadata>
				<g><g transform="translate(0.000000,511.000000) scale(0.100000,-0.100000)"><path d="M4714.2,4982.1c-219-32.5-689.6-34.5-1066.8-6.1c-162.3,14.2-298.1,18.3-304.2,12.2c-22.3-20.3,32.5-168.3,93.3-249.5l60.8-83.2l-81.1-56.8c-217-150.1-415.8-436.1-503-722c-89.2-290-99.4-758.5-24.3-1083c28.4-119.7,26.4-131.8-32.5-131.8c-190.6,0-243.4-241.4-142-659.2c103.4-423.9,223.1-651,336.7-634.8c52.7,8.1,56.8,4.1,99.4-176.5c119.7-496.9,397.5-888.3,762.6-1079c253.5-131.8,484.7-192.7,740.3-192.7c261.6-2,411.7,32.4,665.3,158.2c430,210.9,734.2,634.8,843.7,1174.3c22.3,117.6,26.4,121.7,81.1,115.6c40.6-6.1,73,8.1,115.6,48.7c150.1,144,334.6,837.6,283.9,1064.8c-24.3,107.5-101.4,180.5-186.6,180.5c-48.7,0-58.8,8.1-50.7,36.5c36.5,125.8,77.1,415.8,87.2,624.7c12.2,267.7-10.1,448.2-79.1,632.8c-81.1,215-334.6,409.7-533.4,409.7c-34.5,0-58.8,28.4-109.5,129.8c-115.6,235.3-381.3,430-669.3,490.8C4947.5,5018.6,4945.4,5018.6,4714.2,4982.1z"/><path d="M3213.4-199.9c-188.6-121.7-695.7-375.2-949.2-472.6c-103.4-40.6-286-101.4-405.6-135.9c-344.8-99.4-462.4-172.4-592.2-367.1c-44.6-66.9-105.5-196.7-133.9-286c-48.7-148.1-54.8-206.9-62.9-531.4c-10.1-357,12.2-718,54.8-864c18.3-62.9,40.6-83.2,196.7-164.3c642.9-336.7,1474.5-580,2379.1-697.7c482.7-60.8,1582-58.8,1943,6.1c62.9,10.1,64.9,14.2,50.7,85.2c-24.3,125.7-12.2,490.8,22.3,645c160.2,732.2,744.3,1294,1480.6,1423.8c271.8,48.7,632.8,18.3,912.7-79.1c107.5-36.5,113.6-36.5,113.6-2c0,60.8-62.9,251.5-123.7,371.2c-123.7,245.4-261.6,344.8-616.6,450.2c-466.5,137.9-922.8,338.7-1330.5,584.1l-217,129.8l-381.3-1210.8c-210.9-667.3-389.4-1206.8-395.5-1198.6c-8.1,8.1-79.1,198.8-158.2,425.9l-144,411.7l101.4,166.3c123.7,204.8,182.5,365.1,182.5,505c0,150.1-52.7,229.2-198.8,296.1c-97.4,44.6-144,52.7-292.1,52.7c-156.2-2-192.7-8.1-292.1-60.8c-154.1-79.1-196.7-156.2-184.6-326.5c10.1-135.9,99.4-352.9,217-527.3c34.5-48.7,60.8-95.3,60.8-103.4c2-44.6-292.1-835.6-306.3-821.4c-16.2,16.2-150.1,427.9-533.4,1646.9c-127.8,405.6-235.3,740.3-239.3,742.3C3367.5-104.6,3296.5-147.2,3213.4-199.9z"/><path d="M7251.5-1942.1c-527.3-111.6-941.1-470.5-1109.4-963.4c-73-213-89.2-541.5-40.6-764.6c83.1-373.2,338.7-728.1,663.2-918.8c722-423.9,1650.9-154.1,2016,588.2c144,290,188.6,636.9,121.7,953.2c-16.2,79.1-73,229.2-123.7,334.6c-79.1,160.2-125.8,221.1-269.8,365.1c-190.6,188.6-352.9,288-600.3,365.1C7746.3-1934,7395.5-1911.7,7251.5-1942.1z M7715.9-2804.1v-334.6l340.7-4.1l338.7-6.1l6.1-206.9l6.1-208.9h-346.8h-344.8v-344.8v-344.8H7503h-213v344.8v344.8h-344.8h-346.8l6.1,208.9l6.1,206.9l340.7,6.1l338.7,4.1v334.6v334.6h213h212.9V-2804.1z"/></g></g>
											</svg>
		</button>
	</ng-container>

	<ng-container *ngIf="item.column_type === 'addition'">
		<button class="table-button-add"
				[class.is-open]="showingStepsUserId === elem.id"
				(click)="showStepsInfo(elem, item)"
				title="{{item.column_btn_title}}">
		</button>
	</ng-container>

	<ng-container *ngIf="item.column_type === 'check-box' && canSeeDelete()">
		<mat-checkbox class="check-text" style="padding-left: 0.4em;" [ngModel]="checkAll" (change)="onCheckChange($event ,elem)">
		</mat-checkbox>
	</ng-container>
	<ng-container *ngIf="item.column_type === 'delete' && canSeeDelete()">
		<button title="Delete this note" class="table-button-complete" (click)="onDeleteNote(elem)">
			<svg class="table-button__icon delete-note__delete"  xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 256 256"><path fill="currentColor" d="M216 48h-40v-8a24 24 0 0 0-24-24h-48a24 24 0 0 0-24 24v8H40a8 8 0 0 0 0 16h8v144a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16V64h8a8 8 0 0 0 0-16M96 40a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v8H96Zm96 168H64V64h128Zm-80-104v64a8 8 0 0 1-16 0v-64a8 8 0 0 1 16 0m48 0v64a8 8 0 0 1-16 0v-64a8 8 0 0 1 16 0"/></svg>
		</button>
	</ng-container>

	<ng-container *ngIf="item.column_type === 'tabs' && elem.id === showingStepsUserId && showType == 'number'">
		<app-iris-table-tabs [userId]="elem.id" [guestUser]="getGuestUser(elem)" [tabs]="getTabs(item, elem)"></app-iris-table-tabs>
	</ng-container>

	<ng-container *ngIf="item.column_type === 'tabs' && elem.id === showingStepsUserId && showType == 'string'">
		 <app-diaries [username]="elem.id"></app-diaries>
	</ng-container>

	<ng-container *ngIf="item.column_type === 'select'">
		<mat-form-field appearance="fill" [class.is-hidden]="isStatusHidden(item.column_classes)">
			<mat-select (selectionChange)="onSelectChange($event, elem)"
						[value]="getSelectValue(elem)">
				<mat-option *ngFor="let status of item.column_selectValues" [value]="status.id">
					{{status.title}}
				</mat-option>
			</mat-select>
		</mat-form-field>
	</ng-container>
</ng-template>

<div [class]="getClassList()">
	<cdk-table [dataSource]="tableData">
		<ng-container [cdkColumnDef]="item.column_key" *ngFor="let item of columnData; trackBy: identify">

			<cdk-header-cell [class]="item.column_classes?.join(' ') + ' i-th'"
							 [ngClass]="{'i-btn':item.column_type === 'button'}" *cdkHeaderCellDef>
				<ng-container *ngIf="item.column_type !== 'button'">
					{{item.column_name}}
				</ng-container>
				<ng-container *ngIf="item.column_type === 'button'">
					<ng-template *ngTemplateOutlet="getTemplateRef('HeaderCell')">

					</ng-template>
				</ng-container>

				<ng-container *ngIf="item.column_type === 'check-box' && canSeeDelete()">
					<mat-checkbox class="check-text" style="padding-left: 0.4em;"
					[(ngModel)]="checkAll"
					(change)="onAllCheckChange($event)">
					</mat-checkbox>
				</ng-container>
			</cdk-header-cell>

			<cdk-cell [ngClass]="{
								'i-btn':item.column_type === 'button',
								'i-height-auto':item.column_type === 'tabs',
								'i-no-padding': item.column_type === 'tabs' || item.column_type === 'addition'}"
					  (click)="onCellClick(item.column_key, elem)"
					  *cdkCellDef="let elem" [class]="item.column_classes?.join(' ') + ' i-td'"
					  [title]="item.column_type !== 'select' && item.column_key !== 'note' ? getTitleCellValue(elem, item) : ''">
				<ng-container *ngTemplateOutlet="cellContent; context: {data: {item:item, elem:elem}}">
				</ng-container>
			</cdk-cell>

		</ng-container>

		<cdk-header-row *cdkHeaderRowDef="getCdkHeaderRowDef(columnData)"
						[ngClass]="{'flex-wrap': isRowWrap(), 'hidden': isHiddenCol()}" class="i-tr">
		</cdk-header-row>

		<cdk-row [class]="getRowClasses(row)" (click)="clickTableRow(row)"
				 *cdkRowDef="let row; columns: getCdkHeaderRowDef(columnData)">
		</cdk-row>

	</cdk-table>
</div>
